import './App.css';
import Layout from './componentes/Layout';

function App() {
  return (
    <Layout/>
  );
}

export default App;
